import BaseAPI from 'api/api'
import { FindAllInterface } from 'api/api-interface'

export interface KeywordInterface {
  keywordType: string
  word: string
  status: string
}

export default class TemplateTextApi extends BaseAPI {
  static findAll(props: FindAllInterface): Promise<any> {
    return this.api.get('keywords', { params: { ...props } }).then((res) => res)
  }

  static create(payload: KeywordInterface) {
    return this.api.post('keywords', payload)
  }

  static findById(id: number): Promise<KeywordInterface> {
    return this.api.get(`keywords/${id}`)
  }

  static update(id: number, body: KeywordInterface) {
    return this.api.patch(`keywords/${id}`, body)
  }

  static updateStatus(id: number, status: string): Promise<any> {
    return this.api.patch(`keywords/${id}/status`, { id, status })
  }

  static remove(id: number) {
    return this.api.delete(`keywords/${id}`)
  }
}
